module.exports = __webpack_public_path__ + "static/media/user-analytics.ecedfb40.svg";